webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports) {

module.exports = firebase;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_vue__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            user: null
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
            _this.user = user;
        });
    },

    methods: {
        signIn: function signIn() {
            var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();
            provider.setCustomParameters({
                hd: 'jjp.jp'
            });
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithPopup(provider).then(function () {}).catch(function () {});
        },
        signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut();
        }
    },
    components: {
        'app-main': __WEBPACK_IMPORTED_MODULE_1__Main_vue__["a" /* default */]
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Matrix_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermBuilder_vue__ = __webpack_require__(56);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            people: [],
            peopleMap: {},
            days: [],
            editMode: "preferred",
            status: null
        };
    },
    created: function created() {
        var _this = this;

        var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database();

        db.ref('people').on('value', function (snapshot) {
            var people = [];
            _this.peopleMap = {};
            snapshot.forEach(function (child) {
                var x = child.val();
                x.key = child.key;
                _this.peopleMap[child.key] = x;
                people.push(x);
            });
            _this.people = people;
            _this.recalcSum();
        });
        db.ref('days').on('value', function (snapshot) {
            _this.days = [];
            snapshot.forEach(function (child) {
                var d = child.val();
                d.weekday = new Date(d.year, d.month - 1, d.day).getDay();
                d.key = child.key;
                _this.days.push(d);
            });
            _this.recalcSum();
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('people').off('value');
        __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.database().ref('days').off('value');
    },

    methods: {
        recalcSum: function recalcSum() {
            var _this2 = this;

            console.log("recalc");
            var sumPeople = {
                total: 0, reporter: 0, editor: 0
            };
            this.people.forEach(function (p) {
                sumPeople.total++;
                if (p && p.isEditor) {
                    sumPeople.editor++;
                }
                if (p && p.isReporter) {
                    sumPeople.reporter++;
                }
                p.sumAbsent = 0;
            });

            this.days.forEach(function (d) {
                d.sumPeople = sumPeople;

                var sum = {
                    total: 0, reporter: 0, editor: 0
                };
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(d.preferred || {}).forEach(function (pk) {
                    var p = _this2.peopleMap[pk];
                    if (p) {
                        var s = d.preferred[pk] || null;
                        if (s == 'A' || s == 'a') {
                            sum.total++;
                            if (p && p.isEditor) {
                                sum.editor++;
                            }
                            if (p && p.isReporter) {
                                sum.reporter++;
                            }
                        }
                    }
                });
                d.sumRequiredAbsence = sum;

                sum = {
                    total: 0, reporter: 0, editor: 0
                };
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(d.assigned || {}).forEach(function (pk) {
                    var p = _this2.peopleMap[pk];
                    if (p) {
                        var s = d.assigned[pk];
                        if (s == 'A' || s == 'a') {
                            sum.total++;
                            if (p && p.isEditor) {
                                sum.editor++;
                            }
                            if (p && p.isReporter) {
                                sum.reporter++;
                            }
                            p.sumAbsent += 1;
                        }
                    }
                });
                d.sumAssignedAbsence = sum;
            });
        }
    },
    components: {
        'sched-matrix': __WEBPACK_IMPORTED_MODULE_2__Matrix_vue__["a" /* default */],
        'sched-termbuilder': __WEBPACK_IMPORTED_MODULE_3__TermBuilder_vue__["a" /* default */]
    }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solver__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        solve: function solve() {
            var result = Object(__WEBPACK_IMPORTED_MODULE_1__solver__["a" /* solve */])(this.people, this.days);
            var updates = {};
            for (var dayKey in result) {
                updates['days/' + dayKey + '/assigned'] = result[dayKey];
            }
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/').update(updates);
        },
        addPerson: function addPerson() {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('people').push({
                name: "New Person",
                absentTarget: 10,
                isReporter: true,
                isEditor: false,
                preferred: {},
                assigned: {}
            });
        },
        getAttendanceVector: function getAttendanceVector(person) {
            return this.days.map(function (d) {
                return {
                    dayKey: d.key,
                    preferred: d.preferred && d.preferred[person.key] || null,
                    assigned: d.assigned && d.assigned[person.key] || null
                };
            });
        },
        setAssignedState: function setAssignedState(personKey, dayKey, state) {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + dayKey + '/assigned/' + personKey).set(state);
        },
        setPreferredState: function setPreferredState(personKey, dayKey, state) {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + dayKey + '/preferred/' + personKey).set(state);
        },
        updatePerson: function updatePerson(person, values) {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/people/' + person.key).update(values);
        },
        removePerson: function removePerson(person) {
            if (confirm(person.name + '\u3055\u3093\u3092\u524A\u9664\u3057\u3066\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F')) {
                __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/people/' + person.key).remove();
            }
        },
        setAbsentTarget: function setAbsentTarget(person, value) {
            var v = Math.floor(value);
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/people/' + person.key + '/absentTarget').set(v);
        },
        setNote: function setNote(day, value) {
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + day.key + '/note').set(value);
        },
        setMinReporter: function setMinReporter(day, value) {
            var v = Math.floor(value);
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + day.key + '/minReporter').set(v);
        },
        setMaxReporter: function setMaxReporter(day, value) {
            var v = Math.floor(value);
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + day.key + '/maxReporter').set(v);
        },
        setMinEditor: function setMinEditor(day, value) {
            var v = Math.floor(value);
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days/' + day.key + '/minEditor').set(v);
        }
    },
    props: ['people', 'days', 'editMode'],
    components: {}
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var now = new Date();
        return {
            year: now.getFullYear(),
            month: now.getMonth() + 1
        };
    },

    methods: {
        updateYear: function updateYear(year) {
            this.year = Math.floor(year);
        },
        updateMonth: function updateMonth(month) {
            this.month = Math.floor(month);
        },
        generateTerm: function generateTerm() {
            if (!confirm("カレンダーを初期化します。よろしいですか？")) {
                return;
            }
            var d = new Date(this.year, this.month - 1, 16);
            var days = [];
            for (;;) {
                var key = d.getFullYear() + '-' + ('0' + d.getMonth()).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                var weekday = d.getDay();
                days[key] = {
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    day: d.getDate(),
                    minEditor: 1,
                    minReporter: weekday == 0 || weekday == 6 ? 2 : 4,
                    maxReporter: weekday == 0 || weekday == 6 ? 3 : 10
                };
                d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
                if (d.getDate() == 16) {
                    break;
                }
            }
            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/days').set(days);
        }
    }
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




// Initialize Firebase
var config = {
    apiKey: "AIzaSyB67sS9mME-iOXhq411-6iRSqTSbSCDpsY",
    authDomain: "jjp-yasumi.firebaseapp.com",
    databaseURL: "https://jjp-yasumi.firebaseio.com",
    projectId: "jjp-yasumi",
    storageBucket: "jjp-yasumi.appspot.com",
    messagingSenderId: "633577102826"
};
__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp(config);
console.log("init");

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df2ea36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(60);
function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df2ea36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c30bd4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(59);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48c30bd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c30bd4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Matrix_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7945c390_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Matrix_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7945c390"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Matrix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7945c390_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Matrix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = solve;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function solve(people, days) {
    function makeAssigned(people, days, pool) {
        var gene = pool[0];
        var res = {};
        days.forEach(function (d) {
            var assigned = {};
            people.forEach(function (p) {
                var s = gene.people[p.key][d.key] || null;
                if (s == 'A' || s == 'a') {
                    assigned[p.key] = 'a';
                }
            });
            res[d.key] = assigned;
        });
        return res;
    }

    function generatePool(size, people, days) {
        var pool = [];
        for (var i = 0; i < size; i++) {
            pool.push(generateInitialGene(people, days));
        }
        return pool;
    }

    var pool = generatePool(500, people, days);
    for (var i = 0; i < 20; i++) {
        pool.forEach(function (gene) {
            adjustAbsents(people, days, gene);
        });
        for (var j = 0; j < 10; j++) {
            crossover(people, days, pool);
        }
        for (var _j = 0; _j < 100; _j++) {
            mutate(people, days, pool);
        }
        pool = sortPool(people, days, pool);
        pool = pool.slice(0, 500);
    }
    return makeAssigned(people, days, pool);
}

function sortPool(people, days, pool) {
    pool.forEach(function (gene) {
        var newScore = 0;

        var dayStats = {};
        days.forEach(function (d) {
            dayStats[d.key] = {
                editorAbsent: 0,
                reporterAbsent: 0
            };
        });

        people.forEach(function (p) {
            var absentCount = 0;
            var v = gene.people[p.key];
            for (var dk in v) {
                if (v[dk] == 'a' || v[dk] == 'A') {
                    absentCount++;
                    if (p.isReporter) {
                        dayStats[dk].reporterAbsent++;
                    }
                    if (p.isEditor) {
                        dayStats[dk].editorAbsent++;
                    }
                }
            }
            if (absentCount > p.absentTarget) {
                newScore -= (absentCount - p.absentTarget) * 100;
            } else if (p.absentTarget - absentCount >= 0) {
                newScore -= (p.absentTarget - absentCount) * 100;
            }
        });

        days.forEach(function (d) {
            var numE = d.sumPeople.editor - dayStats[d.key].editorAbsent;
            if (numE < d.minEditor) {
                newScore -= (d.minEditor - numE) * 500;
            }
            var numR = d.sumPeople.reporter - dayStats[d.key].reporterAbsent;
            if (numR < d.minReporter) {
                newScore -= (d.minReporter - numR) * 100;
            }
            if (numR > d.maxReporter) {
                newScore -= (numR - d.maxReporter) * 100;
            }
        });

        var wsize = 7;
        people.forEach(function (p) {
            var vector = gene.people[p.key];
            var s = 0;
            var ws = 0;
            for (var i = 0; i < days.length; i++) {
                var a = vector[days[i].key];
                if (a == 'A' || a == 'a') {
                    s += 1;
                } else {
                    ws += 1;
                }
                if (i >= wsize) {
                    var b = vector[days[i - wsize].key];
                    if (b == 'A' || b == 'a') {
                        s -= 1;
                    } else {
                        ws -= 1;
                    }
                }
                if (i >= wsize - 1) {
                    if (s / wsize > 0.4) {
                        newScore -= s / wsize * 10;
                    }
                    if (ws >= 6) {
                        newScore -= (ws - 5) * 10;
                    }
                }
            }
        });

        gene.score = newScore;
    });

    return pool.sort(function (a, b) {
        return b.score - a.score;
    });
}

function mutate(people, days, pool) {
    var base_gene = pool[Math.floor(Math.random() * pool.length)];
    var new_gene = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(base_gene));
    var p = people[Math.floor(Math.random() * people.length)];
    var vector = new_gene.people[p.key];
    var absent = [];
    var work = [];
    days.forEach(function (d) {
        if (vector[d.key] == 'a') {
            absent.push(d.key);
        }
        if (vector[d.key] == undefined) {
            work.push(d.key);
        }
    });
    if (absent.length != 0 && work.length != 0) {
        var a = absent[Math.floor(Math.random() * absent.length)];
        var w = work[Math.floor(Math.random() * work.length)];
        vector[w] = 'a';
        delete vector[a];
        pool.push(new_gene);
    }
}

function crossover(people, days, pool) {
    var gene_a = pool[Math.floor(Math.random() * pool.length)];
    var gene_b = pool[Math.floor(Math.random() * pool.length)];
    var person = people[Math.floor(Math.random() * people.length)];
    var gene_c = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gene_a));
    gene_c.score = null;
    gene_c.people[person.key] = gene_b.people[person.key];
    var gene_d = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gene_b));
    gene_d.score = null;
    gene_d.people[person.key] = gene_a.people[person.key];
    pool.push(gene_c);
    pool.push(gene_d);
}

function adjustAbsents(people, days, gene) {
    people.forEach(function (p) {
        var v = gene.people[p.key];
        var count = 0;
        for (var dk in v) {
            if (v[dk] == 'a' || v[dk] == 'A') {
                count++;
            }
        }
        if (count < p.absentTarget) {
            var _dk = days[Math.floor(Math.random() * days.length)].key;
            v[_dk] = v[_dk] || 'a';
        } else if (count > p.absentTarget) {
            var _dk2 = days[Math.floor(Math.random() * days.length)].key;
            if (v[_dk2] == 'a') {
                delete v[_dk2];
            }
        }
    });
}

function generateInitialGene(people, days) {
    var gene = {
        people: {},
        score: null
    };
    people.forEach(function (p) {
        var vector = {};
        days.forEach(function (d) {
            var assigned = d.assigned || {};
            if (assigned[p.key] == 'a') {
                vector[d.key] = 'a';
            }

            var preferred = d.preferred || {};
            if (preferred[p.key] == 'A') {
                vector[d.key] = 'A';
            } else if (preferred[p.key] == 'W') {
                vector[d.key] = 'W';
            }

            gene.people[p.key] = vector;
        });
    });
    return gene;
}

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.days.length > 0)?_c('table',{attrs:{"border":"1"}},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("取材人数 (Min)")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_c('input',{attrs:{"min":"0","max":"99","type":"number"},domProps:{"value":d.minReporter},on:{"change":function($event){return _vm.setMinReporter(d, $event.target.value)}}})])})],2),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("取材人数 (Max)")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_c('input',{attrs:{"min":"0","max":"99","type":"number"},domProps:{"value":d.maxReporter},on:{"change":function($event){return _vm.setMaxReporter(d, $event.target.value)}}})])})],2),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("編集人数 (Min)")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_c('input',{attrs:{"min":"0","max":"99","type":"number"},domProps:{"value":d.minEditor},on:{"change":function($event){return _vm.setMinEditor(d, $event.target.value)}}})])})],2),_vm._v(" "),_c('tr',[_c('th',[_vm._v("メンバー")]),_vm._v(" "),_c('th',[_vm._v("休み日数")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('th',{key:d.key},[_c('span',{class:("weekday weekday-" + (d.weekday))},[_vm._v(_vm._s(['日', '月', '火', '水', '木', '金', '土'][d.weekday]))]),_vm._v(" "),_c('br'),_vm._v(_vm._s(d.month)+"/"+_vm._s(d.day)+"\n                "),_c('br'),_c('input',{staticClass:"note",attrs:{"size":"4","placeholder":"メモ"},domProps:{"value":d.note},on:{"change":function($event){return _vm.setNote(d, $event.target.value)}}})])})],2),_vm._v(" "),_vm._l((_vm.people),function(p){return _c('tr',{key:p.key},[_c('td',[_c('input',{attrs:{"size":"6"},domProps:{"value":p.name},on:{"change":function($event){return _vm.updatePerson(p, {name: $event.target.value})}}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.removePerson(p)}}},[_vm._v("削除")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_c('input',{attrs:{"id":"can_report","type":"checkbox"},domProps:{"checked":p.isReporter},on:{"change":function($event){return _vm.updatePerson(p, {isReporter: $event.target.checked})}}}),_vm._v("取材")]),_vm._v(" "),_c('label',[_c('input',{attrs:{"id":"can_edit","type":"checkbox"},domProps:{"checked":p.isEditor},on:{"change":function($event){return _vm.updatePerson(p, {isEditor: $event.target.checked})}}}),_vm._v("組み")])]),_vm._v(" "),_c('td',{class:(_vm.editMode == 'assigned' && p.absentTarget != p.sumAbsent) ? 'error' : ''},[(_vm.editMode == 'assigned')?_c('span',[_vm._v("\n                "+_vm._s(p.sumAbsent)+" /\n                ")]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"number","min":"0","max":"99"},domProps:{"value":p.absentTarget},on:{"change":function($event){return _vm.setAbsentTarget(p, $event.target.value)}}})]),_vm._v(" "),_vm._l((_vm.getAttendanceVector(p)),function(pp){return _c('td',{key:pp.dayKey,class:("daycell " + _vm.editMode + " " + ((_vm.editMode == 'preferred') ? pp.preferred : pp.assigned))},[(_vm.editMode == 'preferred')?_c('div',[_c('label',[_c('input',{attrs:{"type":"radio"},domProps:{"checked":pp.preferred == null},on:{"change":function($event){return _vm.setPreferredState(p.key, pp.dayKey, null)}}}),_vm._v("なし")]),_c('br'),_vm._v(" "),_c('label',[_c('input',{attrs:{"type":"radio"},domProps:{"checked":pp.preferred == 'A'},on:{"change":function($event){return _vm.setPreferredState(p.key, pp.dayKey, 'A')}}}),_vm._v("★休")]),_c('br'),_vm._v(" "),_c('label',[_c('input',{attrs:{"type":"radio"},domProps:{"checked":pp.preferred == 'W'},on:{"change":function($event){return _vm.setPreferredState(p.key, pp.dayKey, 'W')}}}),_vm._v("★出")]),_c('br')]):_vm._e(),_vm._v(" "),(_vm.editMode == 'assigned')?_c('div',[_c('div',{on:{"click":function($event){return _vm.setAssignedState(p.key, pp.dayKey, pp.assigned ? null: 'a')}}},[_c('div',{class:("preferred-ref " + (pp.preferred))},[_vm._v("\n                            "+_vm._s({'A': '休み希望', 'W': '出勤希望', null: '-'}[pp.preferred])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(pp.assigned ? '休み' : '出勤'))])])]):_vm._e()])}),_vm._v(" "),_c('td')],2)}),_vm._v(" "),(_vm.editMode == 'preferred')?_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("休み希望（取材）")]),_vm._v(" "),_c('td'),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_vm._v("\n                "+_vm._s(d.sumRequiredAbsence.reporter)+"\n            ")])})],2):_vm._e(),_vm._v(" "),(_vm.editMode == 'preferred')?_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("休み希望（組み）")]),_vm._v(" "),_c('td'),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_vm._v("\n                "+_vm._s(d.sumRequiredAbsence.editor)+"\n            ")])})],2):_vm._e(),_vm._v(" "),(_vm.editMode == 'preferred')?_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("休み希望（全体）")]),_vm._v(" "),_c('td'),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_vm._v("\n                "+_vm._s(d.sumRequiredAbsence.total)+"\n            ")])})],2):_vm._e(),_vm._v(" "),(_vm.editMode == 'assigned')?_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("実際の取材人数")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key,class:d.sumPeople.reporter - d.sumAssignedAbsence.reporter - d.minReporter < 0 ? 'error' : ''},[_c('strong',[_vm._v(_vm._s(d.sumPeople.reporter - d.sumAssignedAbsence.reporter))]),_vm._v(" ≧ "+_vm._s(d.minReporter)+"\n                ")])})],2):_vm._e(),_vm._v(" "),(_vm.editMode == 'assigned')?_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("実際の編集人数")]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('td',{key:d.key},[_c('span',{class:d.sumPeople.editor - d.sumAssignedAbsence.editor - d.minEditor < 0 ? 'error' : ''},[_c('strong',[_vm._v(_vm._s(d.sumPeople.editor - d.sumAssignedAbsence.editor))]),_vm._v(" ≧ "+_vm._s(d.minEditor)+"\n                ")])])})],2):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',[(_vm.editMode == 'assigned')?_c('button',{on:{"click":function($event){return _vm.solve()}}},[_vm._v("自動最適化")]):_vm._e(),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.addPerson()}}},[_vm._v("メンバー追加")])]),_vm._v(" "),_c('p')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermBuilder_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c91e26e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermBuilder_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c91e26e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermBuilder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c91e26e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermBuilder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"term"},[_c('span',{staticClass:"year"},[_c('input',{staticClass:"year",attrs:{"type":"number","min":"2010","max":"2099"},domProps:{"value":_vm.year},on:{"input":function($event){return _vm.updateYear($event.target.value)}}}),_vm._v("年\n    "),_c('input',{staticClass:"year",attrs:{"type":"number","min":"1","max":"12"},domProps:{"value":_vm.month},on:{"input":function($event){return _vm.updateMonth($event.target.value)}}}),_vm._v("月\n    16日〜")]),_vm._v(" "),_c('div',[_c('button',{on:{"click":function($event){return _vm.generateTerm()}}},[_vm._v("カレンダーを初期化")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sched-termbuilder'),_vm._v(" "),_c('p',[_vm._v("\n        モード:\n        "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMode),expression:"editMode"}],attrs:{"name":"preferred","type":"radio","value":"preferred"},domProps:{"checked":_vm._q(_vm.editMode,"preferred")},on:{"change":function($event){_vm.editMode="preferred"}}}),_vm._v("希望入力")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMode),expression:"editMode"}],attrs:{"name":"assigned","type":"radio","value":"assigned"},domProps:{"checked":_vm._q(_vm.editMode,"assigned")},on:{"change":function($event){_vm.editMode="assigned"}}}),_vm._v("実配置")])]),_vm._v(" "),_c('sched-matrix',{attrs:{"people":_vm.people,"days":_vm.days,"edit-mode":_vm.editMode}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user == null)?_c('div',[_c('button',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("G Suiteアカウントでログイン")])]):_c('div',[_c('span',[_vm._v(_vm._s(_vm.user.displayName)+" ("+_vm._s(_vm.user.email)+")")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.signOut()}}},[_vm._v("ログアウト")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-main',{attrs:{"user":_vm.user}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.6eb0c7c3b88b4e34d8bd.js